<ng-container *transloco="let t">
  <div class="scope-selection">
    <div class="selection-summary">
      <span class="selected-count">
        {{ t('lang.auth_interaction_scope_selected_count', { count: selectedIds().length }) }}
      </span>
    </div>

    <div class="option-list">
      @for (item of pageItems; track item.id) {
        <label class="option-card" [class.selected]="isSelected(item.id)">
          <input
            type="checkbox"
            [checked]="isSelected(item.id)"
            [disabled]="loading"
            (change)="toggleSelection(item.id)" />

          <div class="option-content">
            <p class="option-label">{{ item.label }}</p>
            @if (item.description) {
              <p class="option-description">{{ item.description }}</p>
            }
          </div>

          @if (isSelected(item.id)) {
            <div class="selection-status">
              <mzic-svg src="assets/icons/mzic-check-mark-filled.svg" />
            </div>
          }
        </label>
      } @empty {
        <div class="empty-state">
          <p class="empty-title">{{ t('lang.auth_interaction_scope_empty_title') }}</p>
          <p class="empty-description">{{ t('lang.auth_interaction_scope_empty_description') }}</p>
        </div>
      }
    </div>

    @if (lazyLoading) {
      <div class="lazy-loading-list" data-testid="scope-selection-lazy-skeleton">
        @for (item of shimmerItems; track item) {
          <div class="lazy-loading-card">
            <div class="lazy-loading-content">
              <mzic-skeleton class="lazy-loading-title" />
              <mzic-skeleton class="lazy-loading-subtitle" />
            </div>
            <mzic-skeleton class="lazy-loading-status" />
          </div>
        }
      </div>
    }

    @if (canLoadMore) {
      <aside
        #observerTarget
        class="lazy-loading-observer"
        aria-hidden="true"></aside>
    }
  </div>
</ng-container>
